import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["element"]
  }
  static get values() {
    return { text: String, original: String }
  }

  connect() {
    if (this.hasElementTarget && !this.hasOriginalValue) {
      this.originalValue = this.elementTarget.innerHTML
    }

    if (!this.hasTextValue) {
      this.textValue = i18n.t("js.loading")
    }
  }

  show() {
    if (this.elementTarget.classList.contains("disabled")) {
      return
    }

    this.elementTarget.innerHTML = `<span class='far fa-spinner-third fa-spin'></span> ${this.textValue}`

    if (this.elementTarget.tagName === "BUTTON") {
      this.elementTarget.disabled = true
    }
  }

  hide() {
    this.elementTarget.innerHTML = this.originalValue

    if (this.elementTarget.tagName === "BUTTON") {
      this.elementTarget.disabled = false
    }
  }
}
